import { render, staticRenderFns } from "./SenderAdd.vue?vue&type=template&id=1bf12b38&"
import script from "./SenderAdd.vue?vue&type=script&lang=js&"
export * from "./SenderAdd.vue?vue&type=script&lang=js&"
import style0 from "./SenderAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports